export class AuthHelper {
    public static UserDetails = {
        AccountId : null,
        Email :null,
        FirstName:null,
        LastName:null,
        IsAdmin:null,
    };
}